import * as React from 'react'
import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { LocationDTO, ENTITY_TYPES } from '@sales-center/common'
import { SettingsPage } from '@sales-center/components'
import { DetailsHeader } from './DetailsHeader'
import { Details } from './Details'

type Props = {
  onClose: () => void
  open: boolean
  locations: LocationDTO[]
  locationId: number
  address?: string
  entityId?: number
  entityType?: ENTITY_TYPES
}

export function DetailsDialog(props: Props) {
  const { onClose, open } = props

  return (
    <FullScreenDialog open={open} onClose={onClose} closeButtonText="Close">
      <SettingsPage padding="0px" fullScreen isDetailPage contentHeight="auto">
        <DetailsHeader />
        <Details {...props} />
      </SettingsPage>
    </FullScreenDialog>
  )
}
